import { TripType, useGlobalContext, useSearch } from '@honeycomb/data';
import { useMemo } from 'react';
import { interjectResourceString, pluraliseCount } from '../../../utils';
export const useHotelSearchResultsTitle = (filteredHotelCount, loading = false) => {
    const { resourceStrings: { HOTELS_SRP_TITLE, HOTELS_SRP_TITLE_SINGULAR, HOTELS_SRP_TITLE_LOADING, HOLIDAY_HOTELS_SRP_TITLE, HOLIDAY_HOTELS_SRP_TITLE_SINGULAR, HOLIDAY_HOTELS_SRP_TITLE_LOADING, }, } = useGlobalContext();
    const [{ tripType }] = useSearch([]);
    const isHoliday = tripType === TripType.Holiday;
    return useMemo(() => {
        const titlePlural = isHoliday ? HOLIDAY_HOTELS_SRP_TITLE : HOTELS_SRP_TITLE;
        const titleSingular = isHoliday ? HOLIDAY_HOTELS_SRP_TITLE_SINGULAR : HOTELS_SRP_TITLE_SINGULAR;
        const titleLoading = isHoliday ? HOLIDAY_HOTELS_SRP_TITLE_LOADING : HOTELS_SRP_TITLE_LOADING;
        if (loading) {
            return titleLoading;
        }
        return pluraliseCount(filteredHotelCount, {
            singular: titleSingular,
            plural: interjectResourceString(titlePlural, filteredHotelCount),
        });
    }, [
        HOLIDAY_HOTELS_SRP_TITLE,
        HOLIDAY_HOTELS_SRP_TITLE_LOADING,
        HOLIDAY_HOTELS_SRP_TITLE_SINGULAR,
        HOTELS_SRP_TITLE,
        HOTELS_SRP_TITLE_LOADING,
        HOTELS_SRP_TITLE_SINGULAR,
        filteredHotelCount,
        isHoliday,
        loading,
    ]);
};
